import React, { useRef } from 'react';
import Lock_Ico from '../../../../Assets/Images/lock.png'
import { showToast } from '../../../../Component/Toast';
import Button from '../../../../Component/Button'

function Index(props) {

    let TenantId = useRef(null), EmpCode = useRef(null);

    const submitForm = e => {

		let tenant = TenantId.current.value;
		let emp = EmpCode.current.value;

		if(!tenant || !emp){
			showToast({
				type: 'error',
				message: "Enter both Client Code and Emp Code"
			})
			return
		}
        props.onSuccess(`${tenant}|${emp}`)

	}

    return (
        <>
       <div className="container" style={{height: '100vh'}}>
            <div className="row justify-content-center h-100-center">
                <div className="col-md-6 pt-4">
                    <div data-aos="fade-left" className="p-3 text-center" style={{backgroundColor: '#fff', borderRadius: '1rem', maxWidth: 400, boxShadow: '0 1rem 2rem rgba(0,0,0,.5)!important', margin: 'auto'}}>
                        <img className="img-fluid mb-4" src={Lock_Ico} alt='Lock' style={{maxWidth: 80}} />
                        <h1 className="display-6 fw-bold">Reset Password</h1>
                        <p>Enter your Company code and Employee code</p>
                        <div className="mt-3 mb-4">
                            <div>
                                <div className='mb-2'>
                                    <input ref={TenantId} type="text" className="form-control mb-2" placeholder="Client Code"/>
                                    <input ref={EmpCode} type="text" className="form-control" placeholder="Employee Code"/>
                                </div>
                                <Button onClick={submitForm} name='Next' loading={props.loading} />
                            </div>
                        </div>
                        <p className="mt-3" style={{fontSize: '0.9rem'}}>
                            <a className="text-parimary" href={`/?origin=${props.origin}`}>Back to Login</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default Index;
